export const numberWithCommas = (x) => {
    if (x === null) return;
    return (x || x === 0) ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
};
